export default "__VITE_ASSET__DYfispWa__"